import moment from "moment/moment";

function dayLabel(date, todayLabel) {
  const day = moment(date).startOf("day");
  const today = moment().startOf("day");
  const diff = day.diff(today, "days");
  if (diff <= 0) return todayLabel;
  if (diff === 1) return "Tomorrow";
  return day.format("ddd");
}

/**
 * When a queued post is expected to be commented on, in the user's local time. Only the next post
 * gets a time - the worker picks each later gap at random when it sends, so those only get a day.
 */
export function queueTimeLabel(estimatedAt, isNext) {
  if (!estimatedAt) return null;
  if (isNext) return `${dayLabel(estimatedAt, "Today")} ${moment(estimatedAt).format("h:mm A")}`;
  return dayLabel(estimatedAt, "Later today");
}

/** "eligible again Fri" for a contact in cooldown; null when it ages out first. */
export function eligibleAgainLabel(eligibleAgainAt) {
  if (!eligibleAgainAt) return null;
  return `eligible again ${dayLabel(eligibleAgainAt, "later today").replace("Tomorrow", "tomorrow")}`;
}

const SKIP_REASON_SUMMARY = {
  cooldown: "already engaged",
  expires_before_turn: "aging out",
  repost: (n) => (n === 1 ? "repost" : "reposts"),
  opened: "opened",
};

/** "20 already engaged · 9 reposts · 5 opened" - skipped posts counted by reason, biggest first. */
export function skippedSummary(skipped) {
  const counts = {};
  skipped.forEach((item) => {
    counts[item.reason] = (counts[item.reason] || 0) + 1;
  });
  return Object.entries(counts)
    .sort(([, a], [, b]) => b - a)
    .map(([reason, n]) => {
      const label = SKIP_REASON_SUMMARY[reason] || reason;
      return `${n} ${typeof label === "function" ? label(n) : label}`;
    })
    .join(" · ");
}

export const SKIP_REASON_LABELS = {
  cooldown: "Already engaged recently",
  expires_before_turn: "Too old by the time its turn comes",
  repost: "Repost or reshare",
  opened: "You opened this post",
};
